<template>
	<div>
		<el-dialog :visible.sync="showpushwl" title="推送物流" width="500px" :append-to-body="true" :close-on-click-modal="false"  class="pushwl">
			<div style="text-align: center;">
				<el-form size="mini" :inline="true">
					<el-form-item label="选择店铺">
						<el-select v-model="shopname" :clearable="true" style="width:200px">
							<el-option
							     v-for="item in dslist" :key="item.ds_name" :label="item.ds_name" :value="item.ds_name">
							      <span style="float: left">{{ item.ds_name }}</span>
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<el-button type="success" size="mini" @click="pushwl">确定</el-button>
				<el-button size="mini" @click="showpushwl=false" style="margin-left:10px">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	data() {
		return{
			showpushwl:false,
			dslist:[],
			shopname:'',
			batch:'',
			pageparam:'',
			divid:'pushwl'
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			this.batch='';
			this.pageparam='';
			this.showpushwl=false;
			this.shopname='';
			this.dslist=[];
			if(param.batch!=undefined)
				this.batch=param.batch;
			if(param.pageparam!=undefined)
				this.pageparam=param.pageparam;
			this.loadUserds();
		},
		//加载用户的店铺
		loadUserds(){
			var that=this;
			this.$tool.loading('正在加载', this.divid);
			this.$apipost.get.GetUserds({type:'推送物流'}).then(res => {
				this.$tool.loadingclose();
				if(res.list!=undefined){
					that.dslist=res.list;
					if(that.dslist.length>0){
						if(that.dslist.length>1)
							that.showpushwl=true;
						else{
							that.showpushwl=false;
							that.shopname=that.dslist[0].ds_name;
							that.pushwl();
						}
					}else{
						this.$tool.message('未读取到您的店铺', 0);
					}
				}
			});
		},
		//推送物流
		pushwl(){
			var that=this;
			if(this.shopname==''){
				this.$tool.message('请选择店铺', 0);
				return false;
			}
			var paraminfo={
				batch:this.batch,
				handleraccount:localStorage.getItem('u_account'),
				userid:localStorage.getItem('userid'),
				pageparam:this.pageparam,
				shopname:this.shopname
			}
			if(this.dslist.length>1)
				this.$tool.loading('正在推送', this.divid);
			else
				this.$tool.loading('正在推送', this.pageparam.divclass);
				
			this.$apipost.post.PushOrderWl({paraminfo:paraminfo}).then(res => {
				if(res.state=='1'){
					this.$tool.loadingclose();
					that.showpushwl=false;
					this.$tool.message('推送成功', 1);
				}
				else{
					this.$tool.message(res.message, 0);
					if(res.filename!=undefined){
						if(res.filename!='')
							that.$tool.downfile(that,res.filename,res.batch);
						else
							this.$tool.loadingclose();
					}
					else
						this.$tool.loadingclose();
				}
			});
		}
	}
}
</script>

<style>
</style>
